import { MessageSquare, Phone } from "lucide-react";
import { mediaUrl, telHref } from "@/lib/api";
import { Logo } from "@/components/site/Logo";
import { scrollToId } from "@/components/site/Header";

export const Hero = ({ settings }) => {
  const hero = settings.hero;
  return (
    <section className="grain relative overflow-hidden bg-[#0d0d0f]" data-testid="hero-section" id="hero">
      {hero && (
        <picture>
          <source media="(max-width: 767px)" srcSet={mediaUrl(hero.mobile_url)} />
          <img
            src={mediaUrl(hero.url)}
            alt=""
            fetchPriority="high"
            className="absolute inset-0 h-full w-full object-cover opacity-60"
          />
        </picture>
      )}
      <div className="absolute inset-0 bg-gradient-to-r from-[#121214] via-[#121214]/85 to-[#121214]/30" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#121214] to-transparent" />
      <div className="relative mx-auto flex min-h-[86vh] max-w-7xl flex-col justify-center px-4 pb-16 pt-10 sm:px-8 lg:pb-24">
        <div className="rise max-w-[460px]" style={{ animationDelay: "60ms" }}>
          <Logo logo={settings.logo} size="lg" testId="hero-logo" />
        </div>
        <p className="eyebrow rise mt-8" style={{ animationDelay: "160ms" }}>
          Paint &amp; Body · {settings.location || "Falcon, CO"}
        </p>
        <h1
          className="font-display rise mt-3 max-w-3xl text-5xl leading-[0.95] text-[#FAF7F2] sm:text-6xl lg:text-7xl"
          style={{ animationDelay: "240ms" }}
          data-testid="hero-tagline"
        >
          {settings.tagline}
        </h1>
        <p
          className="rise mt-5 max-w-xl text-base leading-relaxed text-zinc-300 sm:text-lg"
          style={{ animationDelay: "320ms" }}
          data-testid="hero-intro"
        >
          {settings.intro}
        </p>
        <div className="rise mt-9 flex flex-col gap-3 sm:flex-row" style={{ animationDelay: "400ms" }}>
          {settings.primary_phone && (
            <a href={telHref(settings.primary_phone)} className="btn-gold h-14 text-lg" data-testid="hero-call-now-button">
              <Phone className="h-5 w-5" strokeWidth={2.5} /> Call Now
            </a>
          )}
          <button onClick={() => scrollToId("message")} className="btn-ghost h-14 text-lg" data-testid="hero-message-us-button">
            <MessageSquare className="h-5 w-5" /> Message Us
          </button>
        </div>
      </div>
    </section>
  );
};
